export default __webpack_public_path__ + "static/media/menu_icon05.f9fe50a5.png";